import './App.css';
import Home from './Components/Home';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate
} from "react-router-dom";
import Gallery from './Components/Gallery/Gallery';
import About from './Components/About/About';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Consultancy from './Components/Consultancy/Consultancy';
import Teacher from './Components/Consultancy/Teacher';
import ScrollToTop from './Components/ScrollToTop';
import Payment from './Components/Payment';
import International from './Components/InternationalProject/International';
import ProjectDetails from './Components/InternationalProject/ProjectDetails';
import Courses from './Components/OnlineCourse/Courses';
import CourseDetails from './Components/OnlineCourse/CourseDetails';
function App() {
  return (
    <>

      {/* <Router> */}
      <Navbar />
      <Routes>
        {/* <ScrollToTop/> */}
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/globalConsultancy" element={<Consultancy />} />
        <Route path="/globalConsultancy/teacher" element={<Teacher />} />
        <Route path="/globalConsultancy/teacher/Payment" element={<Payment />} />
        <Route path="/internationalProjects" element={<International/>} />
        <Route path="/internationalProjects/project" element={<ProjectDetails/>} />
        <Route path="/internationalProjects/project/Payment" element={<Payment />} />
        <Route path="/onlineCourses" element={<Courses/>} />
        <Route path="/onlineCourses/course" element={<CourseDetails/>} />
        <Route path="/onlineCourses/course/Payment" element={<Payment />} />
        
        

      </Routes>
      <Footer />
      {/* </Router> */}
    </>

  );
}

const withRouter = (Component) => {
  const Wrapper = (props) => {
    const history = useNavigate();

    return (
      <Component
        history={history}
        {...props}
      />
    );
  };

  return Wrapper;
};

export default withRouter(App);